import React from 'react';
import { componentDictionary } from './componentDictionary';
import { Redirect } from 'react-router-dom';

// Definición de componentes


const DynamicComponent = ({ componentName }) => {
  // Obtener el componente basado en el nombre
  const SelectedComponent = componentDictionary[componentName];
  if (!SelectedComponent) {
    return <Redirect to={{ pathname: "/" }} />;
  }

  // Renderizar el componente
  return <SelectedComponent />;
};

export default DynamicComponent;



// WEBPACK FOOTER //
// ./src/middleware/dynamic_component.jsx